import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-sync-dialog',
  template: `
    <h1 mat-dialog-title>Confirmar exclusão</h1>
    <div mat-dialog-content>
    <p>{{messageBody}}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button color="primary" (click)="cancel()">Cancelar</button>
      <button mat-button color="primary"(click)="exclude()">Excluir</button>
    </div>
  `,
  styles: []
})

export class ConfirmDeleteMaterialModalComponent {

  messageBody: string;
  constructor(public dialogRef: MatDialogRef<ConfirmDeleteMaterialModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { messageBody: string }) {
    this.messageBody = data.messageBody;
  }


  exclude() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
} 